export default function contentfilter(data, id) {
  let cont;
  for (const key in data) {
    if (data[key].contentfulid === id) {
      cont = data[key];
    }
  }
  return cont;
}
